import React, { Component } from 'react';
import { connect } from 'react-redux';
import DeviceListComponent from './DeviceList';

class DeviceListContainer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			fromDashboard: (props.location && props.location.state && props.location.state.fromDashboard === true),
			refreshDeviceList: '',
			loading: false,
			searchString: '',
			searchSubmit: '',
			location: ''
		}
	}

	componentDidMount() {

	}

	/** 
	 * 	@description Function to handle search submit
	 *  @param searchString The value in the input field  and field type 
	 *  @memberof DeviceListContainer
	 */
	handleSearchSubmit = (searchString, location) => {
		this.setState({ searchString: searchString, location: location, searchSubmit: true, refreshDeviceList: '' });
	}

	/** 
	 *  @description Function to handle search reset
	 *  @memberof DeviceListContainer
	 */
	handleReset = () => {
		this.setState({ searchString: '', searchSubmit: '', refreshDeviceList: '', location: '' });
	}

	/** 
	 *  @description Function to toggle loader from sub components
	 *  @memberof DeviceListContainer
	 */
	toggleLoader = (status) => {
		this.setState({ loading: status, refreshDeviceList: false, searchSubmit: false });
	}

	render() {
		const { loading, searchString, location, refreshDeviceList, searchSubmit } = this.state;
		return (
			<DeviceListComponent
				refreshDeviceList={refreshDeviceList}
				loading={loading}
				searchString={searchString}
				searchSubmit={searchSubmit}
				handleSearchSubmit={this.handleSearchSubmit}
				handleReset={this.handleReset}
				location={location}
			/>
		);
	}
}

function mapStateToProps(state) {
	return {
		state,
	};
}

export default connect(mapStateToProps)(DeviceListContainer);